import { createReducer } from 'redux-create-reducer'

import {
  FETCH_FAMILY_FRIENDLY_DATA_SUCCESS,
  FETCH_FAMILY_FRIENDLY_REQUEST,
} from 'js/components/shared/constants'

const initialState = {}

export default createReducer(initialState, {
  [FETCH_FAMILY_FRIENDLY_REQUEST](state) {
    return {
      ...state,
    }
  },
  [FETCH_FAMILY_FRIENDLY_DATA_SUCCESS](state, { payload }) {
    return {
      ...state,
      ...payload,
    }
  },
})
